<template>
  <div class="rent-and-buy">
    <v-card class="rent">
      <v-toolbar
        color="#E72480"
        dark
      >

        <v-toolbar-title style="font-weight: bold;font-size: 2rem">خرید و اجاره</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="addDialog" >
          <v-icon>mdi-plus-thick  </v-icon>
        </v-btn>
      </v-toolbar>
      <div class="empty-array" v-if="originalUnits.length===0">اطلاعاتی برای نشان دادن نداریم.</div>
      <div class="empty-array" v-if="originalUnits.length===0">لطفا اطلاعات جدید را وارد کنید.</div>
      <div  class="child-offer">
        <v-card
          v-for="item in originalUnits.results"
          width="380"
          style="margin: 20px auto"
        >
          <div class="image">
            <v-img
              lazy-src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU"
              :src="item.file ? baseUrl+item.file+ '?'+ dates :'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1xSB2iFkkqe-n5iYhIGetiDnHcP-fZg9-Vg&usqp=CAU'"
              height="250px"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div class="icons">
              <v-btn :loading="deleteLoading" style="background-color: white" @click="deleteData(item.id)" icon>
                <v-icon color="red">mdi-delete  </v-icon>
              </v-btn>
              <v-btn @click="editData(item.area , item.plate,item.phoneNo,item.unitCategory,item.rentCost,item.mortgageCost , item.floor,item.id,item.imgPath)" style="background-color: white" icon>
                <v-icon color="blue" >mdi-pencil  </v-icon>
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">متراژ:</div>
                  <div >{{item.area}}</div>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">کد واحد:</div>
                  <div>{{item.plate}}</div>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">موقعیت:</div>
                  <div>{{item.floor}}</div>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">شماره تلفن:</div>
                  <div>{{item.phoneNo}}</div>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">کاربری ساختمان:</div>
                  <div>{{item.unitCategory}}</div>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">قیمت خرید:</div>
                  <div>{{item.mortgageCost}}</div>
                </v-row>
              </v-col>
            </v-row>
            <v-row>

              <v-col cols="12" md="12">
                <v-row  class="flex-direction">
                  <div style="font-weight: bold;font-size: 18px">قیمت اجاره:</div>
                  <div>{{item.rentCost}}</div>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="800"
      class="dialogs"
      v-on:click:outside="eybiyokh"
    >
      <v-card style="background-color: #d2d2d2;padding: 40px">

        <v-form validation v-model="valid">
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
              <v-text-field
                  v-model="telephoneNumber"
                  :rules="[numberRules]"
                  :counter="11"
                  label="شماره تلفن"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="mortgageCost"
                  :rules="[mortgageNumber]"
                  label="قیمت خرید"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="rentCost"
                  :rules="[rentNumber]"
                  label="قیمت اجاره"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="areaNumber"
                :rules="[areaRules]"
                label="متراژ"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-text-field
                v-model="plateNumber"
                :rules="[plateRules]"
                label="پلاک واحد"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              class="select-floor"
            >
              <v-select
                 style="flex-direction: column-reverse"
                 :items="items"
                 label="موقعیت ساختمان"
                 solo
                 v-model="floor"
                 required
                 :rules="[floorRules]"
              ></v-select>
            </v-col>
            <v-col
                cols="12"
                md="3"
                class="select-floor"
              >
                <v-select
                  style="flex-direction: column-reverse"
                  :items="items2"
                  label="دسته بندی"
                  solo
                  required
                  v-model="categories"
                  :rules="[categoriesRules]"
                ></v-select>
              </v-col>
          </v-row>

          <v-col >
            <v-row>
              <v-file-input
                v-model="files"
                class="input"
                chips
                placeholder=""
                :rules="rules1"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                v-on:change="showImage($event)"
                v-on:click:clear="deleteImage"
                required
              ></v-file-input>
              <p class="text">عکس مورد نظر خود را اپلود کنید</p>
            </v-row>
            <v-row style="width: 300px">
              <v-img width="300px" height="200px" class="image-test"  :src="image" alt=""></v-img>
            </v-row>

          </v-col>


        </v-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black darken-1"
            text
            @click="eybiyokh()"
          >
            بیخیال
          </v-btn>
          <v-btn
            color="black darken-1"
            text
            :loading="sendLoading"
            @click="sendData"
            v-show="!isEdit"
            :disabled="!valid"
          >
            انجام شد
          </v-btn>
          <v-btn
            color="black darken-1"
            text
            @click="recordData"
            v-show="isEdit"
            :loading="editLoading"
            :disabled="!valid"
          >
            ویرایش کنید.
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  import {toBase64} from "../../../plugins/toBase64";
  import {deleteUnit, setUnit,putUnit,putUnitImage} from "../../../api/rentAndBuy";
  import {mapActions, mapGetters} from "vuex";
  export default {
    name: "offer",
    data:()=>({
      dialog:false,
      isEdit:false,
      id:0,
      text:'',
      files:[],
      fileCheck:true,
      textCheck:true,
      check:true,
      valid:true,
      rules1: [],
      telephoneNumber: '',
      sendLoading:false,
      editLoading:false,
      deleteLoading:false,
      image:'',
      mortgageCost:0,
      rentCost:0,
      areaNumber:0,
      categories:'',
      plateNumber:"",
      floor:'',
      baseUrl:'',
      dates:'',
      items: [ 'همکف', 'طبقه اول', 'طبقه دوم','طبقه منفی ۱'],
      items2:['تجاری','اداری'],
      numberRules: v  => {
        if( /^\d+$/.test(v)){
          if(v.length===11)
          {
            return true
          }
           return 'شماره موبایل باید ۱۱ رقم باشد.'
        }
        else{
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
        },
      mortgageNumber: v =>{
        if( /^\d+$/.test(v)){
          return true
        }
        else{
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
      },
      rentNumber:v =>{
        if( /^\d+$/.test(v)){
          return true
        }
        else{
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
      },
      areaRules: v =>{
        if( /^\d+$/.test(v)){
          return true
        }
        else{
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
      },
      plateRules: v =>{
        if( /^\d+$/.test(v)){
          return true
        }
        else
        {
          return 'متن وارد شده عدد نیست و اعداد رو به صورت انگلیسی وارد کنید.';
        }
      },
      floorRules: v =>{
        if(v!=='' && v!==undefined)
        {
          return true
        }
        else
        {
          return 'طبقه واحد خود را وارد کنید.'
        }
      },
      categoriesRules : v =>{
        if(v!=='' && v!==undefined)
        {
          return true
        }
        else
        {
          return 'دسته بندی مغازه را مشخص کنید'
        }
      }

    }),
    methods:{
      showImage(e){
        if(e) {
          this.image = URL.createObjectURL(e)
        }
      },
      deleteImage()
      {
        this.image = ''
      },
      addDialog () {
        this.isEdit = false
        this.dialog = true
        this.areaNumber = 0
        this.image = ''
      },
      async sendData(){
        this.sendLoading = true
       let img =  await toBase64(this.files)
          await setUnit({
            area:this.areaNumber,
            phoneNo:this.telephoneNumber,
            unitCategory:this.categories,
            mortgageCost:this.mortgageCost,
            rentCost:this.rentCost,
            buyCost:0,
            floor:this.floor,
            plate:this.plateNumber,
            imgPath:img
          }).then(()=>{
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })
        this.dates = new Date()
        await this.getRentReq()
        this.sendLoading = false
        this.dialog = false
        this.files=[]
        this.text=''
        this.areaNumber = 0
        this.telephoneNumber = ''
        this.mortgageCost = 0
        this.rentCost=0
        this.floor = ''
        this.plateNumber = ''
        this.categories = ''
      },
      async recordData(){
        this.editLoading = true
        if(this.files.length === 0 )
        {
           await putUnitImage({
            area: this.areaNumber,
            phoneNo: this.telephoneNumber,
            devolutionCategory: '',
            unitCategory: this.categories,
            mortgageCost: this.mortgageCost,
            rentCost: this.rentCost,
            buyCost: 0,
            floor: this.floor,
            plate: this.plateNumber,
          }, this.id).then(() => {
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })
        }
        else {
       let img =  await toBase64(this.files)
           await putUnit({
              area: this.areaNumber,
              phoneNo: this.telephoneNumber,
              devolutionCategory: '',
              unitCategory: this.categories,
              mortgageCost: this.mortgageCost,
              rentCost: this.rentCost,
              buyCost: 0,
              floor: this.floor,
              plate: this.plateNumber,
              imgPath: img
            }, this.id).then(() => {
              this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات فرستادن با موفقیت اعمال شد', showSnackbar:true})
            }).catch(()=>{
              this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
            })
        }
        await this.$mount()
        await  this.getRentReq()
        this.dates  = new Date()
        this.editLoading = false
        this.dialog = false
        this.area = 0
        this.telephoneNumber = ''
        this.mortgageCost = 0
        this.rentCost=0
        this.floor = ''
        this.plateNumber = ''
        this.categories = ''

      },
      eybiyokh(){
        this.dialog = false
        this.files=[]
        this.text=''
        this.area = 0
        this.telephoneNumber = ''
        this.mortgageCost = 0
        this.rentCost=0
        this.floor = ''
        this.plateNumber = ''
        this.categories = ''
      },
      async deleteData(id){
        let yes = confirm("مطمئنی میخوای پاک کنی!");
        if (yes) {
          this.deleteLoading = true
          await deleteUnit(id).then(() => {
            this.getRentReq()
            this.dates = new Date()
            this.snackBarAction({color:"#4CAF50" , textSnackBar:'عملیات حذف شدن اعمال شد.', showSnackbar:true})
          }).catch(()=>{
            this.snackBarAction({color:"#ff5252" , textSnackBar:'متاسفانه تغییرات اعمال نشد', showSnackbar:true})
          })
        }
        this.deleteLoading = false
      },
      editData(area ,plate,phoneNo,unitCategory,rentCost,mortgageCost , floor,id,image){
          this.files = []
          this.areaNumber = area
          this.telephoneNumber = phoneNo
          this.categories = unitCategory
          this.mortgageCost = mortgageCost
          this.rentCost = rentCost
          this.floor = floor
          this.plateNumber = plate
          this.id=id
          this.dialog = true
          this.isEdit = true
          this.image  = this.baseUrl+image+'?'+this.dates;
      },
      ...mapActions({
        getRentReq:'rentAndBuyStore/fetchRent',
        snackBarAction: 'snackBar/snackBarAction',
        setLoading : 'setLoading'
      }),

    },
    computed: {
      ...mapGetters({
        originalUnits: 'rentAndBuyStore/get_rent',
      })
    },
    async mounted() {
      this.setLoading(true)
      this.dates = new Date()
      this.baseUrl = process.env.VUE_APP_BASE_URL
      await this.getRentReq()
      this.setLoading(false)
    },

  }
</script>
<style>
  .offer .v-icon.v-icon::after{
    background-color: unset;
  }
  .text-input .v-label.v-label  {
    font-size: 1.1rem !important;
    top: 0;
  }
  .text-input .v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot{
    height: 2rem !important;
  }
  .text-input .v-textarea textarea{
    font-size: 1.25rem;
  }
  .date-input{
    margin-bottom: 2rem;
  }
  .select-floor .v-input__control{
    flex-direction: column-reverse;
  }
 .rent-and-buy .row {
    margin-right: unset !important;
  }
</style>

<style scoped>
  .flex-direction{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  .rent{
    width: 85%;
    margin: 0 auto;
  }
  .child-offer{
    padding: 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
  }
  .card-offer{
    margin: 0;
  }
  .form-slider{
    display: flex;
    flex-direction: column;
    max-width: 1185px;
    margin: 0 auto;
  }
  .title-input
  {
    min-height: unset;
  }
  .input{
    direction: ltr;
  }
  .row{
    justify-content: center;
    align-items: flex-end;
    flex-direction: row-reverse;
  }
  .flex-direction{
    flex-direction: row;
    justify-content: flex-start;
  }
  .text{
    font-family: anjoman;
    font-size: 1.25rem;
  }

  .link-input{
    width: 40%;
  }
  .image{
    position:  relative;
  }
  .icons{
    position: absolute;
    top: 0;
    left: 0;
  }
  .empty-array{
    font-size: 2rem;
    margin-right: 3rem;
    font-weight: bold;
  }
</style>
